import { NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { DevoCommitmentsPageService } from '../devo-commitments.page.service';
import { DevoCommitmentsCommitmentsViewPart } from './commitments/devo-commitments-commitments-view.part';


@Component({
	selector: 'devo-commitments-views-part',
	standalone: true,
	imports: [
		DevoCommitmentsCommitmentsViewPart,
		DroplistWidget,
		NgSwitch,
		NgSwitchCase
	],
	templateUrl: './devo-commitments-views.part.html',
})
export class DevoCommitmentsViewsPart {

	public service = inject(DevoCommitmentsPageService);

	// ngOnInit() {
	// 	this.service.initializeUrl();
	// }

}